import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CircleNotch, CheckCircle, XCircle } from "@phosphor-icons/react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sid) return setStatus("error");
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/stripe/status/${sid}`);
        if (data.payment_status === "paid") return setStatus("paid");
        if (data.status === "expired") return setStatus("expired");
        if (++attempts >= 6) return setStatus("timeout");
        setTimeout(poll, 2000);
      } catch {
        if (++attempts >= 6) return setStatus("error");
        setTimeout(poll, 2000);
      }
    };
    poll();
  }, [sid]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#F9F7F4]">
      <div className="card !p-10 max-w-md text-center" data-testid="payment-success-card">
        {status === "checking" && <><CircleNotch size={40} className="animate-spin mx-auto text-[#0A3622]" /><h2 className="font-display text-2xl mt-4 font-medium">Verifying payment…</h2></>}
        {status === "paid" && <><CheckCircle size={48} weight="fill" className="mx-auto text-[#2D7A5D]" /><h2 className="font-display text-2xl mt-4 font-medium">Payment received</h2><p className="text-sm text-[#4F5D4F] mt-2">Thanks — funds will reflect shortly.</p></>}
        {(status === "expired" || status === "timeout" || status === "error") && <><XCircle size={48} weight="fill" className="mx-auto text-[#C93B3B]" /><h2 className="font-display text-2xl mt-4 font-medium">Payment not confirmed</h2><p className="text-sm text-[#4F5D4F] mt-2">Please contact support if your card was charged.</p></>}
        <button onClick={() => nav("/parent")} className="btn-primary mt-6" data-testid="payment-success-back">Back to dashboard</button>
      </div>
    </div>
  );
}
